import {sandboxSvg as Icon__small__sandboxSvg} from '../Icon__small/Icon__small--sandbox.js';
import {sandboxSvg as Icon__xsmall__sandboxSvg} from '../Icon__xsmall/Icon__xsmall--sandbox.js';

export var sandbox = {
  name: 'sandbox',
  category: 'icon',
  colorable: true,
  svg: Icon__small__sandboxSvg,
  alt: {
    Icon__small: Icon__small__sandboxSvg,
    Icon__xsmall: Icon__xsmall__sandboxSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
